import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Generic from '../../../components/molecule/SortableElements/Generic';
import FloatingSelect from '../../../components/molecule/FloatingSelect';
import Button from '../../../components/atomic/Buttons/Button';
import FileUploader from '../../../components/atomic/Inputs/FileUploader';
import {
  ACCEPTED_VIDEO_FORMATS, STREAMING_STATUS
} from '../../../core/constants';
import * as apiServices from '../../../services/apiServices';
import LinearProgress from '@material-ui/core/LinearProgress';
import VideoSelect from '../../../components/molecule/FormFields/VideoSelect';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AlertModal } from '../../../components/molecule/Modals/AlertModal';



const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
`;

const SetWrapper = styled.div`
  border: 1px solid #ccc;
  background: #eee;
  border-radius: 10px;
  display: flex;
  padding: 10px;
  margin-bottom: 25px;
  flex-direction: column;
  width: 100%;
`;

const SetHeader = styled.div`
  color: #999;
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
`;

const CardStyled = styled(Card)`
  display: flex;
  min-height: 75px;
  min-width: 400px;
  margin: 10px 0;
`;
const CardMediaStyled = styled(CardMedia)`
  min-width: 75px;
  min-height: 75px;
`;
const Details = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 100%;
`;

const UploadButtonContainer = styled.div`
  
`
const OptionSelect = styled.div`
  direction: rtl;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  ${'' /* height: 100%; */}
  // background: rgba(0,0,0,0.1);
  ${'' /* flex-shrink: 1; */}
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`
const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  // height: 160px;
`

const VideoSelectStyled = styled(VideoSelect)`
  direction: ltr;
  display: flex;
  width: 100%;
`
const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`

const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`

const ProgramSets = ({ sets, onRemove, onSortEnd, addWorkout, userData, startPolling, values, setFieldValue, programOverviewVideos, programFormState, submitForm }) => {
  return (
    <Container>
      {sets.map((programSet, index) => (
        <ProgramSet
          key={`program-set-${index}`}
          programSet={programSet}
          setIndex={index}
          onRemove={onRemove}
          onSortEnd={onSortEnd}
          addWorkout={addWorkout}
          userData={userData}
          startPolling={startPolling}
          values={values}
          setFieldValue={setFieldValue}
          programOverviewVideos={programOverviewVideos}
          programFormState={programFormState}
          submitForm={submitForm}
        />
      ))}
    </Container>
  );
}

const SortableClass = SortableElement(({ item, classIndex, setIndex, onRemove }) => {
  return (
  <Generic index={classIndex} onClick={() => onRemove(setIndex, classIndex)}>
    <CardStyled>
      {
        item.image && item.image.url && <CardMediaStyled image={item.image.url} />
      }
      <Details>{item.title}</Details>
    </CardStyled>
  </Generic>
  );
});

const SortableSetContainer = SortableContainer(({ classes, setIndex, onRemove }) => {
  return (
    <div>
      {classes.map((item, index) => (
        <SortableClass
          key={`sortable-class-${setIndex}-${index}`}
          index={index}
          item={item}
          classIndex={index}
          setIndex={setIndex}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
});

const ProgramSet = ({ programSet, setIndex, onRemove, onSortEnd, addWorkout, userData, startPolling, values, setFieldValue, programOverviewVideos, programFormState, submitForm }) => {

  const [beforeVideoUploadProgress, setBeforeVideoUploadProgress] = useState(0)
  const [afterVideoUploadProgress, setAfterVideoUploadProgress] = useState(0)
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (programFormState.isSubmitting && !submitted) {
      submitForm();
      setSubmitted(true);
    }
  }, [programFormState.isSubmitting]);

  useEffect(() => {
    if (!programFormState.isSubmitting && submitted) {
      setSubmitted(false);
    }
  }, [programFormState.isSubmitting, submitted]);

  useEffect(() => {
    if(programOverviewVideos[values.id]?.videoBefore){
      const mockSets = values.sets.map(set => {
        if (programOverviewVideos && programOverviewVideos[values.id] && set.id === programOverviewVideos[values.id]?.setId) {
          const { videoId, thumbnail, streaming_status, streaming_video, video } = programOverviewVideos[values.id];
          set.video_before = set.video_before ?? {};
          set.video_before.id = videoId;
          set.video_before.streaming_video = video;
          set.video_before.thumbnail = thumbnail;
          set.video_before.streaming_status = streaming_status;
          set.video_before.video = streaming_video;
        }
        return set;
      });
      changeTracker(mockSets, 'sets')
    } 
    if(!programOverviewVideos[values.id]?.videoBefore){
      const mockSets = values.sets.map(set => {
        if (programOverviewVideos && programOverviewVideos[values.id] && set.id === programOverviewVideos[values.id]?.setId) {
          const { videoId, thumbnail, streaming_status, streaming_video, video } = programOverviewVideos[values.id];
          set.video_after = set.video_after ?? {};
          set.video_after.id = videoId;
          set.video_after.streaming_video = video;
          set.video_after.thumbnail = thumbnail;
          set.video_after.streaming_status = streaming_status;
          set.video_after.video = streaming_video;
        }
        return set;
      });
      changeTracker(mockSets, 'sets')
    } 
  }, [programOverviewVideos, programSet, values.id]);


  const changeTracker = (value, name) => setFieldValue(name, value, true);

  const removeBeforeVideo = () => {
    const mockSets = values.sets.map(set => {
      if (set.id === programSet.id) {
        delete set.video_before;
      }
      return set;
    });

    changeTracker(mockSets, 'sets')
  }

  const removeAfterVideo = () => {
    const mockSets = values.sets.map(set => {
      if (set.id === programSet.id) {
        delete set.video_after;
      }
      return set;
    });
    changeTracker(mockSets, 'sets')
  }

  const beforeVideoUploadFinished = ({ awsUrl }) => {
    apiServices.addOverviewVideo({
      exercise: values.id,
      streaming_status: STREAMING_STATUS.PROCESSING,
      subtitle: '',
      video: awsUrl,
    }).then(data => {
      setBeforeVideoUploadProgress(0);
      startPolling({
        id: values.id,
        videoId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'programOverviewVideos',
        setId: programSet.id,
        videoBefore: true,
        video: awsUrl,
      });
      apiServices.updateProgramSet(
        values.id,
        programSet.id, 
        {video_before_id: data.id}
      )
    });
  }

  const afterVideoUploadFinished = ({ awsUrl }) => {
    apiServices.addOverviewVideo({
      exercise: values.id,
      streaming_status: STREAMING_STATUS.PROCESSING,
      subtitle: '',
      video: awsUrl,
    }).then(data => {
      setAfterVideoUploadProgress(0);
      startPolling({
        id: values.id,
        videoId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'programOverviewVideos',
        setId: programSet.id,
        videoBefore: false,
        video: awsUrl,
      });
      apiServices.updateProgramSet(
        values.id,
        programSet.id, 
        {video_after_id: data.id}
      )
    });
  }
  const updateBeforeVideoUploadProgress = (videoUploadProgress) => {
    setBeforeVideoUploadProgress(videoUploadProgress);
  }
  const updateAfterVideoUploadProgress = (videoUploadProgress) => {
    setAfterVideoUploadProgress(videoUploadProgress);
  }
  const videoPlaceholderText = 'No Video';
  return (
    <SetWrapper>
      <SetHeader>{programSet.name}</SetHeader>
      <SortableSetContainer
        classes={programSet.classes}
        setIndex={setIndex}
        onRemove={onRemove}
        onSortEnd={(o) => onSortEnd(o, setIndex)}
        useDragHandle
      />
      <FloatingSelect>
        <VideoContainer>
          <UploadButtonContainer>
            <FileUploader
              accept={ACCEPTED_VIDEO_FORMATS}
              buttonText="Before Video"
              fileType="video"
              fullWidth
              metadata={{ trainer_id: userData.user_id.toString()}}
              onFinish={beforeVideoUploadFinished}
              onProgress={updateBeforeVideoUploadProgress}
              variant='contained'
            />
          </UploadButtonContainer>
          <OptionWrapper>
                    <OptionSelect>
                      {
                        (programSet?.video_before) ? (
                          <VideoSelectStyled
                            onDelete={() => AlertModal('Delete Video','Are you sure you want to delete this video?', () => removeBeforeVideo())}
                            processing={(programSet && programSet?.video_before?.streaming_status === STREAMING_STATUS.PROCESSING)}
                            thumbnail={programSet?.video_before?.thumbnail}
                            video={programSet?.video_before?.video ? programSet?.video_before?.video : programSet?.video_before?.streaming_video}
                          />
                        ) : (
                          <ImageWrapper style={{opacity: 0.3}}>
                            <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                            {videoPlaceholderText}
                            {
                              (programSet?.video_before?.streaming_status === STREAMING_STATUS.PROCESSING) &&
                                <CircularProgress />
                            }
                          </ImageWrapper>
                        )
                      }
                    </OptionSelect>
                  </OptionWrapper>
                  { beforeVideoUploadProgress > 0 && (
                    <UploadProgressContainer>
                      <LinearProgress variant="determinate" value={beforeVideoUploadProgress} />
                    </UploadProgressContainer>
                  )}
        </VideoContainer>
        <Button color="primary" variant="contained" onClick={() => addWorkout(setIndex)}>
          Add Workout
        </Button>
        <VideoContainer>
          <UploadButtonContainer>
            <FileUploader
              accept={ACCEPTED_VIDEO_FORMATS}
              buttonText="After Video"
              fileType="video"
              fullWidth
              metadata={{ trainer_id: userData.user_id.toString()}}
              onFinish={afterVideoUploadFinished}
              onProgress={updateAfterVideoUploadProgress}
              variant='contained'
            />
          </UploadButtonContainer>
          <OptionWrapper>
                    <OptionSelect>
                    {
                        (programSet?.video_after) ? (
                          <VideoSelectStyled
                            onDelete={() => AlertModal('Delete Video','Are you sure you want to delete this video?', () => removeAfterVideo())}
                            processing={(programSet && programSet?.video_after?.streaming_status === STREAMING_STATUS.PROCESSING)}
                            thumbnail={programSet?.video_after.thumbnail}
                            video={programSet?.video_after?.video ? programSet?.video_after?.video : programSet?.video_after?.streaming_video}
                          />
                        ) : (
                          <ImageWrapper style={{opacity: 0.3}}>
                            <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                            {videoPlaceholderText}
                            {
                             (programSet && programSet?.video_after?.streaming_status === STREAMING_STATUS.PROCESSING) &&
                                <CircularProgress />
                            }
                          </ImageWrapper>
                        )
                      }
                    </OptionSelect>
                  </OptionWrapper>
                  { afterVideoUploadProgress > 0 && (
                    <UploadProgressContainer>
                      <LinearProgress variant="determinate" value={afterVideoUploadProgress} />
                    </UploadProgressContainer>
                  )}
        </VideoContainer>
      </FloatingSelect>
    </SetWrapper>
  )
}

export default ProgramSets;